function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2.71,
  d: "M.958 1.042l5 5M9.042 1.042l-5 5"
});

function SvgSelectArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEwIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIwLjk1Nzk2MyIgeTE9IjEuMDQyMDQiIHgyPSI1Ljk1ODA2IiB5Mj0iNi4wNDIxMyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjcwOTUzIi8+CjxsaW5lIHkxPSItMS4zNTQ3NiIgeDI9IjcuMDcxMiIgeTI9Ii0xLjM1NDc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43MDcxMDcgMC43MDcxMDcgMC43MDcxMDcgMC43MDcxMDcgMTAgMikiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi43MDk1MyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };